import { useEffect, useState } from "react";
import { AdminProfileForm } from "./addUsersForm";
import { BankProfileForm } from "./addBankUserForm";
import { AgentProfileForm } from "./addAgentUserForm";
import { useAuthData } from "../../../context/AuthContext";

export const Profile = () => {
  const { adminData } = useAuthData();

  const [Role, setRole] = useState(null);
  const [IsAdmin, setIsAdmin] = useState(null);
  useEffect(() => {
    const getData = async () => {
      if (adminData) {
        if (adminData?.role) {
          setRole(adminData?.role);
        }

        setIsAdmin(adminData?.is_admin ?? false);
      }
    };

    getData();
  }, [adminData]);
  return (
    <>
      {Role === "Admin" && <AdminProfileForm />}
      {Role === "Bankansvarlig" && <BankProfileForm />}
      {Role === "super-admin" && <BankProfileForm />}
      {Role === "Agent" && IsAdmin === true ? (
        <AgentProfileForm />
      ) : (
        Role === "Agent" && IsAdmin === true && <AdminProfileForm />
      )}
    </>
  );
};
